import { useEffect } from 'react'
import { dispatchSetBrowserIsOnline } from '$comp/main/root.action'
import { browserIsOnlineView } from '$comp/main/root.reducer'
import { useSelector } from 'react-redux'

export function useBrowserConnectionState() {
  useEffect(() => {
    function handleChange() {
      dispatchSetBrowserIsOnline(window.navigator.onLine)
    }

    handleChange()

    window.addEventListener('online', handleChange)
    window.addEventListener('offline', handleChange)

    return () => {
      window.removeEventListener('offline', handleChange)
      window.removeEventListener('online', handleChange)
    }
  }, [])
}

export function useBrowserIsOnline() {
  return !!useSelector(browserIsOnlineView)
}
